// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15xer","col":"styles_col__w4lkJ"};